export const UTM_RECHARGE_DROP_PARAM = 'tap_recharge_drop'

export const RECHARGE_DROP_DONE_LS_KEY =
  'claimed_019d2946-ede3-7101-a86b-770978bacaca'

export const RECHARGE_DROP_IS_AVAILABLE_LS_KEY = 'recharge_drop_is_available'

export const NOT_COIN_CLAIM_AVAILABLE_LS_KEY = 'notcoin_claim_available'
export const UTM_NOT_COIN_CLAIM_PARAM = 'glance_not'
export const NOT_COIN_CLAIM_DONE_LS_KEY = 'notcoin_claim_done'
